import script from "./BarraSuperior.vue?vue&type=script&lang=ts&setup=true"
export * from "./BarraSuperior.vue?vue&type=script&lang=ts&setup=true"

import "./BarraSuperior.vue?vue&type=style&index=0&id=054d0f7e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-054d0f7e"]])

export default __exports__